import $ from 'jquery';

export default function tabs() {
  $(document).on('click', '.js-tabs-btn', function (e) {
    e.preventDefault();

    const $tabsWrap = $(this).closest('.js-tabs');
    const tab = $(this).data('tab');
    const $activeBtn = $(this).add(`.js-tabs-btn[data-tab="${tab}"]`);

    $tabsWrap
      .find('.js-tabs-btn')
      .not($activeBtn)
      .not($tabsWrap.find('.js-tabs .js-tabs-btn'))
      .removeClass('is-active')
      .addClass('is-disabled');
    $tabsWrap
      .find('.js-tabs-panel, .js-tabs-content')
      .not(`.js-tabs-panel[data-tab="${tab}"]`)
      .not(`.js-tabs-content[data-tab="${tab}"]`)
      .not($tabsWrap.find('.js-tabs .js-tabs-panel, .js-tabs .js-tabs-content'))
      .removeClass('is-active');

    if ( $(this).data('toggle') !== undefined ) {
      $activeBtn.removeClass('is-disabled').toggleClass('is-active');
      $tabsWrap
        .find(
          `.js-tabs-panel[data-tab="${tab}"], .js-tabs-content[data-tab="${tab}"]`
        )
        .toggleClass('is-active');
    } else {
      $activeBtn.removeClass('is-disabled').addClass('is-active');
      $tabsWrap
        .find(
          `.js-tabs-panel[data-tab="${tab}"], .js-tabs-content[data-tab="${tab}"]`
        )
        .addClass('is-active');
    }

    if (
      !$tabsWrap
        .find('.js-tabs-btn.is-active')
        .not($tabsWrap.find('.js-tabs .js-tabs-btn.is-active')).length
    ) {
      $tabsWrap.find('.js-tabs-btn').removeClass('is-disabled');
    }
  });
}


// WEBPACK FOOTER //
// ./src/assets/js/project/tabs.js